<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <div class="filter-box">
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
        </div>
      </div>
      <TableList
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :tableName="TableName.TABLE_DEPARTMENT"
        :permissionName="permissionName"
        @command-change="handleCommand"
        :canRefresh="false"
        :canChangeColumn="false"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_ADD` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('addRow', scope.row)"
          >
            {{ t("table.add") }}
          </el-link>
          <el-link
            v-permission="{ pkey: `${permissionName}_EDIT` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            {{ t("table.edit") }}
          </el-link>
          <el-link
            v-permission="{ pkey: `${permissionName}_DELETE` }"
            href="javascript:void(0);"
            type="danger"
            @click="handleCommand('delete', scope.row)"
          >
            {{ t("table.delete") }}
          </el-link>
        </template>
      </TableList>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="'dept'"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { deleteDepartmentById, defaultDeptModel, getDeptDetailByDeptId, getDeptTree } from '@/apis/department'
import { getDropdownByType } from '@/apis/tool'
import { DeptModel, NatureOptionsModel, ArrayRowsItem } from '@/model/Index'

import { useI18n } from 'vue-i18n'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'
export default defineComponent({
  name: 'Department',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()
    const dataMap = reactive({
      TableName,
      permissionName: permissionName.DEPARTMENT,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,

      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        name: undefined,
        nature: undefined
      },
      activeId: 0,
      superId: 0,
      parentId: {},

      deptTop: {
        id: 0,
        name: '顶级部门'
      },
      natureOptions: [],
      superIdOptions: [],
      dialogFormVisible: false,
      submitLoading: false,
      tempDeptModel: defaultDeptModel,

      getList() {
        dataMap.listLoading = true
        getDeptTree().then((res: any) => {
          dataMap.list = res || []
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
        // getDeptByDeptId(dataMap.superId, dataMap.listQuery).then((res: any) => {
        //   dataMap.list = res || []
        //   dataMap.listLoading = false
        // }).catch(() => {
        //   dataMap.listLoading = false
        // })
      },
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate(dataMap.deptTop)
            break
          case 'addRow':
            dataMap.handleCreate(val)
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleSubmit()
            break
        }
      },
      handleSubmit() {
        dataMap.getList()
      },
      // lazyLoadData(row: any, treeNode: any, resolve: any) {
      //   getDeptByDeptId(row.id).then((res: any) => {
      //     resolve(res || [])
      //   })
      // },
      handleCreate(row: any) {
        dataMap.activeId = 0
        dataMap.loadFormDataSlectOption(row)
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleDelete(row: any) {
        dataMap.parentId = row.superId
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteDepartmentById(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getDeptDetailByDeptId(row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            k.formList.forEach((field: any) => {
              field.value = res[field.fieldKey] || field.value
              if (field.fieldKey === 'superId') {
                if (field.value) {
                  getDeptDetailByDeptId(row.superId).then((data: any) => {
                    field.option = [{
                      id: row.superId,
                      name: data.name
                    }]
                  })
                } else {
                  field.option = [dataMap.deptTop]
                }
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      loadFormDataSlectOption(row: any) {
        dataMap.initFormData.forEach((item: any) => {
          item.formList.forEach((k: any) => {
            if (k.fieldKey === 'superId') {
              k.value = row.id
              k.option = [{
                id: row.id,
                name: row.name
              }]
            }
          })
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      }
    })
    onMounted(() => {
      dataMap.loadTableSelectOption()
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
